import {DossierT2000} from "./base.model";

export class OrgNameType {
  orgNameFullRu?: DossierT2000 = '';
  orgNameRu?: DossierT2000 = '';
  orgNameFullIn?: DossierT2000 = '';
  orgNameIn?: DossierT2000 = '';
}
